import { Link } from "react-router-dom";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { QUICK_ACTIONS } from "@/lib/sections";
import { cn } from "@/lib/utils";

const pill =
  "inline-flex h-10 items-center gap-2 rounded-full border px-4 text-[13.5px] transition-[background-color,border-color,color] duration-150";
const idle = "border-white/[0.1] bg-transparent text-zinc-300 hover:border-white/[0.2] hover:bg-white/[0.04] hover:text-white";

export function QuickActions({ mode, onMode }) {
  return (
    <div className="mt-5 flex flex-wrap justify-center gap-2" data-testid="home-quick-actions">
      {QUICK_ACTIONS.map(({ key, label, icon: Icon, live, note, to }) =>
        to ? (
          <Link key={key} to={to} className={cn(pill, idle)} data-testid={`quick-action-${key}`}>
            <Icon className="h-4 w-4" strokeWidth={1.6} />
            {label}
          </Link>
        ) : live ? (
          <button
            key={key}
            type="button"
            onClick={() => onMode(key)}
            aria-pressed={mode === key}
            className={cn(pill, mode === key ? "border-white/25 bg-white/[0.08] text-white" : idle)}
            data-testid={`quick-action-${key}`}
          >
            <Icon className="h-4 w-4" strokeWidth={1.6} />
            {label}
          </button>
        ) : (
          <Popover key={key}>
            <PopoverTrigger asChild>
              <button type="button" className={cn(pill, idle)} data-testid={`quick-action-${key}`}>
                <Icon className="h-4 w-4" strokeWidth={1.6} />
                {label}
              </button>
            </PopoverTrigger>
            <PopoverContent className="w-64 border-white/10 bg-ink-850 p-4" data-testid={`quick-action-${key}-note`}>
              <div className="text-[11px] font-medium uppercase tracking-[0.16em] text-zinc-500">Coming in a later phase</div>
              <p className="mt-2 text-sm text-zinc-200">{note}</p>
              <p className="mt-1.5 text-xs text-zinc-500">Chat, Fast Search and Deep Search are available today.</p>
            </PopoverContent>
          </Popover>
        ),
      )}
    </div>
  );
}
